module.exports = __webpack_public_path__ + "static/media/Buildingonly.0218a7ed.svg";